import { useAuth } from '../auth/AuthProvider.js';
import { Button } from '../components/ui/button.js';

/**
 * What an unauthenticated visitor sees - AUTH-003, AUTH-004.
 *
 * Both buttons leave for the Cognito hosted UI rather than posting a form here.
 * The pool owns the password policy, the email verification and the MFA
 * enrolment (`auth-stack.ts`), and a second implementation of any of them would
 * be a second thing to get wrong.
 */
export function SignedOut() {
  const { signIn, signUp, returning } = useAuth();

  return (
    <section className="mx-auto flex max-w-md flex-col gap-4 p-8">
      <h1 className="text-xl font-semibold">Coworker</h1>
      <p className="text-sm text-muted-foreground">
        {returning
          ? 'Your session ended. Sign in again to pick up where you left off.'
          : 'Sign in, or create an account to get your first workspace.'}
      </p>
      <div className="flex gap-3">
        <Button onClick={() => void signIn(window.location.pathname)}>Sign in</Button>
        <Button variant="outline" onClick={() => void signUp()}>
          Create an account
        </Button>
      </div>
    </section>
  );
}
